/**
 * Muscle Code Amino Capsule page – layout wrappers & page tweaks
 */
;(function () {
  const PAGE_CLASS = 'template-page-muscle-code-amino-capsule'

  function isMcPage() {
    return document.body.classList.contains(PAGE_CLASS)
  }

  function getMainSections() {
    const main = document.getElementById('MainContent')
    if (!main) return []
    return [...main.querySelectorAll(':scope > .shopify-section')]
  }

  function wrapSectionRange(wrapperClass, startIdx, endIdx, sections) {
    if (startIdx < 0 || endIdx < startIdx) return null

    const wrapper = document.createElement('div')
    wrapper.className = wrapperClass
    sections[startIdx].before(wrapper)

    sections.slice(startIdx, endIdx + 1).forEach((section) => {
      wrapper.appendChild(section)
    })

    return wrapper
  }

  function addCornerVectors(wrapper, corners) {
    if (!wrapper || wrapper.querySelector('.mc-corner-vectors')) return

    const container = document.createElement('div')
    container.className = 'mc-corner-vectors'
    container.setAttribute('aria-hidden', 'true')

    corners.forEach((corner) => {
      const el = document.createElement('span')
      el.className = `mc-corner-vector mc-corner-vector--${corner}`
      container.appendChild(el)
    })

    wrapper.prepend(container)
  }

  function wrapMcScienceGroup() {
    const sections = getMainSections()
    const startIdx = sections.findIndex((section) =>
      section.querySelector('.mc-science'),
    )
    const endIdx = sections.findIndex((section) =>
      section.querySelector('.mc-advisory-board'),
    )

    wrapSectionRange('mc-science-group', startIdx, endIdx, sections)
  }

  function wrapMcMidGroup() {
    const sections = getMainSections()
    const startIdx = sections.findIndex((section) =>
      section.querySelector('.mc-how-it-works'),
    )
    const endIdx = sections.findIndex((section) =>
      section.querySelector('.swiper--customers'),
    )

    const wrapper = wrapSectionRange('mc-mid-group', startIdx, endIdx, sections)
    addCornerVectors(wrapper, ['top-right', 'bottom-left', 'bottom-right'])
  }

  function wrapMcBottomGroup() {
    const sections = getMainSections()
    const startIdx = sections.findIndex((section) =>
      section.querySelector('.mc-ingredients'),
    )
    const socialIdx = sections.findIndex((section) =>
      section.textContent.includes('Tag @NautilusOfficial'),
    )
    const endIdx = socialIdx >= 0 ? socialIdx + 1 : -1

    const wrapper = wrapSectionRange(
      'mc-bottom-group',
      startIdx,
      endIdx,
      sections,
    )
    addCornerVectors(wrapper, ['top-right'])
  }

  function hideHeaderNav() {
    document.querySelectorAll('.header__inline-menu').forEach((el) => {
      el.style.display = 'none'
    })
  }

  function wrapMcProductTopGroup() {
    const sections = getMainSections()
    const startIdx = sections.findIndex((section) =>
      section.querySelector('.mc-icons-bar'),
    )
    const endIdx = sections.findIndex((section) =>
      section.querySelector('.multicolumn'),
    )

    wrapSectionRange('mc-product-top-group', startIdx, endIdx, sections)
  }

  function setupMcProductChoiceAnchor() {
    const heading = document.querySelector('.mc-product-choice-heading')
    if (heading) heading.id = 'mc-product-choice'
  }

  function setupMcSmoothScroll() {
    document.addEventListener('click', (event) => {
      const link = event.target.closest('a[href^="#"]')
      if (!link || !link.hash || link.hash === '#') return

      const target = document.querySelector(link.hash)
      if (!target) return

      event.preventDefault()

      const header = document.querySelector('sticky-header')
      const headerHeight = header ? header.offsetHeight : 0
      const top =
        target.getBoundingClientRect().top + window.scrollY - headerHeight

      window.scrollTo({ top, behavior: 'smooth' })
    })
  }

  document.addEventListener('DOMContentLoaded', () => {
    if (!isMcPage()) return

    wrapMcProductTopGroup()
    wrapMcMidGroup()
    wrapMcScienceGroup()
    wrapMcBottomGroup()
    hideHeaderNav()
    setupMcProductChoiceAnchor()
    setupMcSmoothScroll()
  })
})()
